// Environment variables for client-side use

// Window ENV augmentation
declare global {
  interface Window {
    ENV?: {
      SUPABASE_URL?: string;
      SUPABASE_ANON_KEY?: string;
    };
  }
}

// Supabase configuration
export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || window.ENV?.SUPABASE_URL || '';
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || window.ENV?.SUPABASE_ANON_KEY || '';

// Add validation for required env vars
export function validateEnv() {
  if (!SUPABASE_URL) {
    console.error('Missing environment variable: VITE_SUPABASE_URL');
  }
  
  if (!SUPABASE_ANON_KEY) {
    console.error('Missing environment variable: VITE_SUPABASE_ANON_KEY');
  }
  
  return SUPABASE_URL && SUPABASE_ANON_KEY;
}
